<template>
    <div v-if="nonSystem.length" class="relative">
        <ui-dropdown-item icon="fas fa-download"
                          v-if="selected.length === 1 && selected[0].type==='file'"
                          @click="downloadNode(lastSelected);closeMenus()">Download File
        </ui-dropdown-item>
        <ui-dropdown-item icon="far fa-file-archive"
                          v-else-if="selected.length > 1 || (selected.length===1 && selected[0].type==='directory')"
                          @click="downloadNodesAsZip(selected);closeMenus()">Download As Zip
        </ui-dropdown-item>
        <ui-dropdown-item icon="fa fa-pencil"
                          v-if="selected.length === 1 && selected[0].type==='file' && enterNodeRename"
                          @click="(e) => {enterNodeRename(lastSelected);closeMenus()}">
            Rename File
        </ui-dropdown-item>
        <ui-dropdown-item icon="fa fa-print"
                          v-if="selected.length === 1 && selected[0].type==='file' && (isImageType(selected[0].mimeType) || selected[0].mimeType === 'application/pdf')"
                          @click="print(lastSelected);closeMenus()">Print File
        </ui-dropdown-item>
        <ui-dropdown-item ref="revisionitem"
                          v-if="selected.length === 1 && selected[0].type==='file' && uploadRevision"
                          @mouseleave="(e) => {$refs['revisionmenu-' + id].close(e) }"
                          @mouseenter="openRevisionSubMenu"
                          icon="fas fa-code-branch"
                          :submenu="true"
        >Revisions
            <div class="fixed" style="width:auto;height:auto;overflow: visible" :ref="'revisionrelative-'+id">
                <vue-context :ref="'revisionmenu-'+id" class="inline pb-0 focus:outline-none focus:ring-0 z-30"
                             :close-on-click="false" :close-on-scroll="false">
                    <div :id="'revisionmenu-'+id"
                         class="p-3 w-72 z-30 bg-white rounded-lg border border-gray-300 shadow-lg">
                        <ui-dropdown-item :key="selected[0].id"
                                          :button-class="'flex w-full'"
                                          @click.prevent.stop="download(selected[0]);closeMenus()">
                            <div class="flex-none text-left w-full">
                <span class="block overflow-hidden whitespace-nowrap text-s p-0 text-ellipsis font-semibold">
                    {{ selected[0].name }}
                </span>
                                <span class="block overflow-hidden whitespace-nowrap text-xs p-0 flex-none">
                    {{ selected[0].createdAt.format('D MMM YY - h:mm:ss a') }}</span>
                            </div>
                        </ui-dropdown-item>
                        <ui-dropdown-item v-for="(revision,index) in (selected[0].revisions)"
                                          :key="revision.id"
                                          :button-class="'flex w-full'"
                                          @click.prevent.stop="download(revision);closeMenus()">
                            <div class="flex-none text-left w-full">
                <span class="block overflow-hidden whitespace-nowrap text-s p-0 text-ellipsis font-semibold">
                    {{ revision.name }}
                </span>
                                <span class="block overflow-hidden whitespace-nowrap text-xs p-0 flex-none">
                    {{ revision.createdAt.format('D MMM YY - h:mm:ss a') }}</span>
                            </div>
                        </ui-dropdown-item>
                        <ui-dropdown-divider></ui-dropdown-divider>
                        <ui-dropdown-item icon="fa fa-upload"
                                          @click.prevent.stop="(e) => {uploadRevision(lastSelected);closeMenus()}">
                            Upload new Revision
                        </ui-dropdown-item>
                    </div>
                </vue-context>
            </div>
        </ui-dropdown-item>
        <ui-dropdown-item ref="tagitem" icon="fa fa-tags"
                          v-if="(nonSystem.length>0)"
                          @mouseleave="(e) => {if (newTag===false) $refs['tagmenu-' + id].close(e)}"
                          @mouseenter="openTagSubMenu"
                          :submenu="true"
        >Tags
            <div class="fixed" style="width:auto;height:auto;overflow: visible" :ref="'tagrelative-'+id">
                <vue-context :ref="'tagmenu-'+id" class="inline pb-0 focus:outline-none focus:ring-0 z-30"
                             :close-on-click="false" :close-on-scroll="false">
                    <div :id="'tagmenu-'+id"
                         class="p-3 w-56 z-30 bg-white rounded-lg border border-gray-300 shadow-lg">
                        <ui-dropdown-item v-for="(tag,index) in (this.filesystem.tags)"
                                          :class="'focus:ring-0'"
                                          :ticked="nonSystem.every((i) => i.tags.includes(tag.name))"
                                          :both="!nonSystem.every((i) => i.tags.includes(tag.name)) && nonSystem.some((i) => i.tags.includes(tag.name))"
                                          :key="tag.name"
                                          @click.prevent.stop="nonSystem.every((i) => i.tags.includes(tag.name))?removeTag(nonSystem,tag.name):addTag(nonSystem,tag.name)">
                            <div class="w-4 h-4 rounded-full flex-none mt-0.5 mr-2"
                                 :style="'background-color: '+tag.colorHex">
                            </div>
                            {{ tag.name }}
                        </ui-dropdown-item>
                        <div v-if="newTag!==false">
                            <input name="newTag" v-model="newTag"
                                   @keydown="newTagKeyDown"
                                   @blur.prevent.stop="updateNewTag(selected)"
                                   ref="tag-name"
                                   class="w-full block overflow-scroll border-none shadow-none ring-0 outline-none bg-transparent text-sm p-0 mt-0 mx-0 mb-0"
                            />
                        </div>
                        <ui-dropdown-divider v-if="this.filesystem.tags.length"></ui-dropdown-divider>
                        <ui-dropdown-item icon="fas fa-tags"
                                          @click.prevent.stop="addNewTag(selected[0])">Add new
                            Tag
                        </ui-dropdown-item>
                    </div>
                </vue-context>
            </div>
        </ui-dropdown-item>
        <ui-dropdown-divider
            v-if="selected.length === 1 && selected[0].type==='file' && isImageType(selected[0].mimeType) && selected[0].supportsRotations"></ui-dropdown-divider>
        <ui-dropdown-item ref="rotateitem" icon="fa fa-sync"
                          v-if="selected.length === 1 && selected[0].type==='file' && isImageType(selected[0].mimeType) && selected[0].supportsRotations"
                          @mouseleave="(e) => {$refs['rotatemenu-' + id].close(e)}"
                          @mouseenter="openRotateSubMenu"
                          :submenu="true"
        >Rotate
            <div class="fixed" style="width:auto;height:auto;overflow: visible" :ref="'rotaterelative-'+id">
                <vue-context :ref="'rotatemenu-'+id" class="inline pb-0 focus:outline-none focus:ring-0 z-30"
                             :close-on-click="false" :close-on-scroll="false">
                    <div :id="'rotatemenu-'+id"
                         class="p-3 w-56 z-30 bg-white rounded-lg border border-gray-300 shadow-lg">
                        <ui-dropdown-item icon="fas fa-undo" @click="rotateLeft(selected[0])">Rotate Left
                        </ui-dropdown-item>
                        <ui-dropdown-item icon="fas fa-undo -scale-x-100" @click="rotateRight(selected[0])">
                            Rotate Right
                        </ui-dropdown-item>
                    </div>
                </vue-context>
            </div>
        </ui-dropdown-item>
        <ui-dropdown-divider
            v-if="selected.length>0  && (deleteNodes || enterNodeRename)"></ui-dropdown-divider>
        <ui-dropdown-item icon="fas fa-trash" danger
                          v-if="selected.length === 1 && selected[0].type==='file' && !selected[0].system && deleteNodes"
                          @click="deleteNodes(nonSystem); closeMenus()">Delete File
        </ui-dropdown-item>
        <ui-dropdown-item icon="fa fa-pencil"
                          v-if="selected.length === 1 && selected[0].type==='directory' && !selected[0].system"
                          @click="(e) => {enterNodeRename(lastSelected);closeMenus()}">
            Rename Folder
        </ui-dropdown-item>
        <ui-dropdown-divider
            v-if="selected.length === 1 && selected[0].type==='directory' && !selected[0].system"></ui-dropdown-divider>
        <ui-dropdown-item icon="fas fa-trash" danger
                          v-if="selected.length === 1 && selected[0].type==='directory' && !selected[0].system && deleteNodes"
                          @click="deleteNodes(nonSystem);closeMenus()">Delete Folder
        </ui-dropdown-item>
        <ui-dropdown-item icon="fas fa-trash" danger
                          v-if="selected.length > 1 && deleteNodes"
                          @click="deleteNodes(nonSystem);closeMenus()">Delete Items
            ({{ selected.filter((i) => !i.system).length }})
        </ui-dropdown-item>
    </div>
    <div v-else>
        <ui-dropdown-item icon="far fa-file-archive"
                          v-if="selected.length > 1 || (selected.length===1 && selected[0].type==='directory')"
                          @click="downloadNodesAsZip(selected);closeMenus()">Download As Zip
        </ui-dropdown-item>
    </div>
</template>

<script>
import UiDropdownDivider from "../ui/UiDropdownDivider.vue";
import UiDropdownItem from "../ui/UiDropdownItem.vue";
import moment from "moment";

export default {
    components: {UiDropdownItem, UiDropdownDivider},
    props: {
        rotations: Object,
        selected: Array,
        lastSelected: false,
        id: '',
        nonSystem: Array,
        canShowInfo: true,
        filesystem: Object,
        closeMenus: Function,
        deleteNodes: false,
        enterNodeRename: false,
        downloadNode: Function,
        downloadNodesAsZip: Function,
        uploadRevision: false,
        prefs: Object,
        tags: true,
    },
    data() {
        return {
            newTag: false,
            iframe: false,
        }
    },
    computed: {},
    methods: {
        download(revision) {
            let a = document.createElement("a")
            document.body.appendChild(a)
            a.style = "display: none"
            a.href =  revision.url + '?forceDownload=1';
            a.download = "download"
            a.click();
            document.body.removeChild(a)
        },
        openTagSubMenu(e) {
            this.$refs["tagmenu-" + this.id].open(new window.MouseEvent('mouse'))
            this.positionTagMenu()
        },
        openRevisionSubMenu(e) {
            this.$refs["revisionmenu-" + this.id].open(new window.MouseEvent('mouse'))
            this.positionRevisionMenu()
        },
        openRotateSubMenu(e) {
            this.$refs["rotatemenu-" + this.id].open(new window.MouseEvent('mouse'))
            this.positionRotateMenu()
        },
        positionTagMenu() {
            this.$nextTick(() => {
                this.$refs["tagrelative-" + this.id].setAttribute('style', '')
                this.$nextTick(() => {
                    const opener = this.$refs.tagitem.$refs.submenu.getBoundingClientRect()
                    const box = this.$refs["tagmenu-" + this.id].$el.getBoundingClientRect()
                    let left = Math.min(opener.x - box.x - 10, window.innerWidth - (box.right) - 17);
                    let top = Math.min(opener.y - box.y - 10, window.innerHeight - (box.bottom) - 28);
                    this.$refs["tagrelative-" + this.id].setAttribute('style', 'margin-left:' + left + 'px; margin-top:' + top + 'px')
                })
            })
        },
        positionRevisionMenu() {
            this.$nextTick(() => {
                this.$refs["revisionrelative-" + this.id].setAttribute('style', '')
                this.$nextTick(() => {
                    const opener = this.$refs.revisionitem.$refs.submenu.getBoundingClientRect()
                    const box = this.$refs["revisionmenu-" + this.id].$el.getBoundingClientRect()
                    let left = Math.min(opener.x - box.x - 10, window.innerWidth - (box.right) - 17);
                    let top = Math.min(opener.y - box.y - 10, window.innerHeight - (box.bottom) - 28);
                    this.$refs["revisionrelative-" + this.id].setAttribute('style', 'margin-left:' + left + 'px; margin-top:' + top + 'px')
                })
            })
        },
        positionRotateMenu() {
            this.$nextTick(() => {
                this.$refs["rotaterelative-" + this.id].setAttribute('style', '')
                this.$nextTick(() => {
                    const opener = this.$refs.rotateitem.$refs.submenu.getBoundingClientRect()
                    const box = this.$refs["rotatemenu-" + this.id].$el.getBoundingClientRect()
                    let left = Math.min(opener.x - box.x - 10, window.innerWidth - (box.right) - 17);
                    let top = Math.min(opener.y - box.y - 10, window.innerHeight - (box.bottom) - 28);
                    this.$refs["rotaterelative-" + this.id].setAttribute('style', 'margin-left:' + left + 'px; margin-top:' + top + 'px')
                })
            })
        },
        async addTag(nodes, tag) {
            await this.filesystem.addTagToNodes(nodes, tag);
        },
        async removeTag(nodes, tag) {
            await this.filesystem.removeTagFromNodes(nodes, tag);
        },
        addNewTag(node) {
            this.newTag = ''
            this.$nextTick(() => {
                if (this.$refs["tag-name"]) {
                    this.$refs["tag-name"].focus()
                }
                this.positionTagMenu()
            })
        },
        newTagKeyDown(e) {
            if (e.key.toUpperCase() === 'ENTER') {
                this.$refs["tag-name"].blur()
                e.preventDefault();
            } else if (e.key.toUpperCase() === 'ESCAPE') {
                this.newTag = false
                this.$refs["tag-name"].blur()
            } else if (e.key.toUpperCase() === ' ') {
                e.preventDefault()
                this.newTag += ' '
            }
        },
        async updateNewTag(nodes) {
            if ((this.newTag !== false) && (this.newTag.trim() !== '')) {
                await this.filesystem.addTagToNodes(nodes, this.newTag);
            }
            this.newTag = false;
        },
        toggleInfo() {
            this.prefs.showInfo = !this.prefs.showInfo
            this.setPrefs();
        },
        setPrefs() {
            this.$emit('setPrefs', this.prefs)
        },
        print(node) {
            let url = this.getPrintUrl(node)

            if (this.iframe) {
                document.body.removeChild(this.iframe)
            }
            this.iframe = document.createElement('iframe');
            this.iframe.setAttribute('style', 'visibility: hidden;height:calc(100vh);position:absolute;z-index:-9999');
            this.iframe.src = "";
            this.iframe.name = 'pdf';
            this.iframe.onload = () => {
                if (!this.isImageType(node.node.mimeType)) {
                    this.$nextTick(() => {
                            setTimeout(() => {
                                const pdfFrame = window.frames["pdf"];
                                pdfFrame.focus();
                                pdfFrame.print();
                            }, 100)
                        }
                    )
                }
            }
            document.body.appendChild(this.iframe);
            this.iframe.src = url + '?time=' + moment().format('x') + (this.isImageType(node.node.mimeType) ? '&asImageWebpage=1' : '');
        },
        getPrintUrl(node) {
            if (!node.node.supportsRotations) {
                return route('api.v2.filesystem.print', [this.filesystem.id, node.node.id])
            }
            let rot = this.rotations[node.node.id];
            if (!rot) {
                return route('api.v2.filesystem.print', [this.filesystem.id, node.node.id])
            }
            return route('api.v2.filesystem.print.rotated', [this.filesystem.id, node.node.id, rot])
        },
        isImageType(mime) {
            if (mime.startsWith('image/')) {
                return true;
            }
            return false
        },
        rotateLeft(node) {
            let rotations = localStorage.getItem('node-rotations')
            rotations = rotations ? JSON.parse(rotations) : {'key': 0}
            rotations[node.id] = ((rotations[node.id] ? rotations[node.id] : 0) - 90) % 360
            rotations[node.id] = ((rotations[node.id] % 360) + 360) % 360;
            rotations.key++;
            if (node.rotations[rotations[node.id]] === null) {
                this.generateRotations(node)
            }
            localStorage.setItem('node-rotations', JSON.stringify(rotations))
            Object.assign(this.rotations, rotations);
        },
        rotateRight(node) {
            let rotations = localStorage.getItem('node-rotations')
            rotations = rotations ? JSON.parse(rotations) : {'key': 0}
            rotations[node.id] = ((rotations[node.id] ? rotations[node.id] : 0) + 90) % 360
            rotations[node.id] = ((rotations[node.id] % 360) + 360) % 360;
            rotations.key++;
            if (node.rotations[rotations[node.id]] === null) {
                this.generateRotations(node)
            }
            localStorage.setItem('node-rotations', JSON.stringify(rotations))
            Object.assign(this.rotations, rotations);
        },
        async generateRotations(node) {
            this.waiting = true;
            this.$modals.wait({
                title: 'Generating Rotations...',
                cancel: () => {
                    this.waiting = false;
                    this.$modals.close()
                }
            })
            await this.filesystem.generateRotations(node)
            if (this.waiting) {
                this.waiting = false;
                this.$modals.close()
            }
        }
    },
    mounted() {
    }
}
</script>

